// @copyright  2006 - 2023 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'book-keeping-setting.page.edit.title': 'Update Closing Date',

    'book-keeping-setting.button.save': 'Save Changes',
    'book-keeping-setting.button.update': 'Update',
    'book-keeping-setting.button.cancel': 'Cancel',

    'book-keeping-setting.label.book_closing_date': 'Current Closing Date',
    'book-keeping-setting.label.new_closing_date': 'New Closing Date',
    'book-keeping-setting.label.not_set': 'Not Closed',

    'book-keeping-setting.modal.title.book_closing_date_update': 'Update Closing Date',
    'book-keeping-setting.modal.message.book_closing_date_update': 'This will prevent transactions from being created on or before this date.<br/> <br/> Are you sure you want to close the books as at {date}?',
    'book-keeping-setting.success.message.book_closing_date_updated': 'Your closing date was successfully updated',
};
